import React from 'react';
import ButtonConfirm from './buttonConfirm.jsx';

const Index = (props) => {
		
	return(

		<ButtonConfirm text={props.text} handleClick={props.handleClick} />

	)

}

export default Index;